define('plugin/invoice/collection/InvoiceRecurringProfileCollection',['require','lib/collection/ServerPaginatedCollection','plugin/invoice/model/InvoiceRecurringProfileModel'],function (require) {

    var ServerPaginatedCollection = require('lib/collection/ServerPaginatedCollection');
    var InvoiceRecurringProfileModel = require('plugin/invoice/model/InvoiceRecurringProfileModel');

    /**
     * Invoice recurring profile collection
     *
     * @class InvoiceRecurringProfileCollection
     */
    return ServerPaginatedCollection.extend({

        url: '/ext/invoice/recurring-profile',
        model: InvoiceRecurringProfileModel

    });

});
